//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../components/Table/Table.vue'
import ReadonlyDocumentsField from '../../components/File/ReadonlyDocumentsField.vue'

import StockInventoryTool from './StockInventoryTool.vue'
import { formatTime, formatTrueFalse } from '../../components/helpers.js'
import { formatFieldDiffAmount, getToolRecordSurplusState, formatUniqueToolName } from './stockInventoryTools.js'
import ReportMaterialsImageBtn from '../Report/ReportMaterials/ReportMaterialsImageBtn.vue'

export default {
  components: {
    Table,
    ReadonlyDocumentsField,
    ReportMaterialsImageBtn
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      default: null
    },
    additionalAccessAdd: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0,
        page: 1,
        sortBy: 'id',
        descending: true
      }
    }
  },
  computed: {
    request: function () {
      return this.record.request
    },
    requestProperties: function () {
      return this.record.requestProperties
    },
    propertyConfig: function () {
      return this.record.requestProperties.toolRecords
    },
    toolRecords: function () {
      return this.request.toolRecords || []
    },
    activeToolRecords: function () {
      return this.toolRecords.filter(r => !r.removed && !r.withdrawTime) || []
    },
    surplusRecords: function () {
      const filteredSurplusRecords = this.activeToolRecords && this.activeToolRecords.filter(r => r.amountDiffType && r.amountDiffType.id === 'surplus') || []
      return filteredSurplusRecords
    },
    readonly: function () {
      return !this.toolRecord
    },
    accessEdit: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable && this.additionalAccessAdd
    },
    accessAdd: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable && !this.readonly && this.additionalAccessAdd
    },
    accessDelete: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable && !this.readonly
    },
    accessEditTool: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable
    },
    resultHidden: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultHidden
    },
    surplusTransferAvailable: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferAvailable
    },
    surplusTransferAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferAccess && this.surplusTransferAvailable
    },
    surplusTransferConfirmationAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferConfirmationAccess && this.surplusTransferAvailable
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    columns: function () {
      return this.getColumns()
    }
  },
  methods: {
    disableSurplusTransfer: function (toolRecord) {
      const surplusState = this.getToolRecordSurplusState(toolRecord)
      return !surplusState.surplusTransferred && !surplusState.surplusTransferRequired || (surplusState.surplusTransferConfirmed && !this.surplusTransferConfirmationAccess)
    },
    disableSurplusTransferConfirmation: function (toolRecord) {
      const surplusState = this.getToolRecordSurplusState(toolRecord)
      return !surplusState.surplusTransferred || !this.surplusTransferConfirmationAccess
    },
    getToolRecordSurplusState: function (toolRecord) {
      return getToolRecordSurplusState(toolRecord, this.propertyConfig)
    },
    onSurplusTransferConfirmation: function (toolRecord) {
      toolRecord = this.request.toolRecords.find(r => r.id === toolRecord.id)

      if (toolRecord.surplusTransferConfirmationTime) {
        toolRecord.surplusTransferConfirmationTime = null
        toolRecord.surplusTransferConfirmationUser = null
      } else {
        const user = this.$store.getters.getUser
        toolRecord.surplusTransferConfirmationTime = Date.now()
        toolRecord.surplusTransferConfirmationUser = user.name
      }
      this.$set(toolRecord, 'edited', true)
    },
    onSurplusTransfer: function (toolRecord) {
      toolRecord = this.request.toolRecords.find(r => r.id === toolRecord.id)

      if (toolRecord.surplusTransferTime) {
        toolRecord.surplusTransferTime = null
        toolRecord.surplusTransferUser = null
        toolRecord.surplusTransferPhotos = []
        toolRecord.surplusTransferConfirmationTime = null
        toolRecord.surplusTransferConfirmationUser = null
        this.$set(toolRecord, 'edited', true)
      } else {
        this.onOpen(toolRecord, true)
      }
    },
    onOpen: function (row, addSurplusTransferPhotos = false) {
      const toolRecord = JSON.parse(JSON.stringify(this.request.toolRecords.find(r => r.id === row.id)))
      const dialog = this.$d.dialog(this)
      if (addSurplusTransferPhotos) {
        toolRecord.surplusTransferTime = Date.now()
        const user = this.$store.getters.getUser
        toolRecord.surplusTransferUser = user.name
      }
      dialog.show({
        maximized: this.mobile,
        class: 'tool-record--dialog',
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryTool,
        contentProps: {
          toolRecord: toolRecord,
          toolRecordStr: JSON.stringify(toolRecord),
          record: this.record,
          additional: toolRecord.additional,
          addSurplusTransferPhotos: addSurplusTransferPhotos
        },
        componentHandlers: {
          close: function () {
            dialog.hide()
          },
          save: (newToolRecord) => {
            const toolRecord = this.request.toolRecords.find(r => r.id === newToolRecord.id)
            toolRecord.tool = newToolRecord.tool
            toolRecord.amountReal = newToolRecord.amountReal
            toolRecord.unit = newToolRecord.unit
            toolRecord.photos = newToolRecord.photos
            toolRecord.amountDiff = newToolRecord.amountDiff
            toolRecord.amountDiffType = newToolRecord.amountDiffType
            toolRecord.changeTime = Date.now()
            toolRecord.withdrawTime = newToolRecord.withdrawTime
            toolRecord.withdrawUser = newToolRecord.withdrawUser
            toolRecord.surplusTransferTime = newToolRecord.surplusTransferTime
            toolRecord.surplusTransferUser = newToolRecord.surplusTransferUser
            toolRecord.surplusTransferPhotos = newToolRecord.surplusTransferPhotos
            toolRecord.surplusTransferConfirmationTime = newToolRecord.surplusTransferConfirmationTime
            toolRecord.surplusTransferConfirmationUser = newToolRecord.surplusTransferConfirmationUser
            this.$set(toolRecord, 'edited', true)

            dialog.hide()
          }
        }
      })
    },
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0 && val !== 'Нет'
      return col.showAlways || hasColumnValue
    },
    getColumns: function () {
      const columns = [
        {
          name: 'toolName',
          label: 'Номенклатурная позиция',
          field: 'tool',
          format: value => value && formatUniqueToolName(value) || 'Неизвестная позиция',
          sortable: true
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1C',
          field: 'tool',
          format: value => value && value.key || '',
          sortable: true
        },
        {
          name: 'surplusState',
          label: 'Статус сдачи излишков',
          format: (surplusState, row) => {
            return this.getToolRecordSurplusState(row).state
          },
          sortable: true,

          hiddenLabel: this.mobile,
          first: this.mobile
        },
        {
          name: 'amountDiff',
          label: 'Расхождение',
          labelTable: 'Расхождение',
          defaultWidth: 100,
          field: formatFieldDiffAmount,
          sortable: true
        },
        {
          name: 'surplusTransferConfirmation',
          label: 'Сдача излишков подтверждена',
          format: (surplusTransferConfirmation, row) => {
            let text = formatTrueFalse(!!row.surplusTransferConfirmationTime)
            if (row.surplusTransferConfirmationTime) {
              text += ', ' + formatTime(row.surplusTransferConfirmationTime)
            }
            if (row.surplusTransferConfirmationUser) {
              text += ', ' + row.surplusTransferConfirmationUser
            }
            return text
          },
          sortable: true
        },
        {
          name: 'surplusTransferPhotos',
          label: 'Фото сдачи излишков',
          defaultWidth: 100,
          format: (surplusTransferPhotos, row) => {
            const photos = []
            surplusTransferPhotos.forEach(photo => {
              const fileId = photo.id != null ? photo.id : photo
              photos.push({
                name: 'Заявка на инвентаризацию' + '-' + (row.tool && row.tool.name || 'Неизвестная позиция') + '-' + fileId,
                id: fileId,
                _key: 'surplusTransferPhotosTable'
              })
            })
            return photos
          },
          sortable: true
        }
      ]

      return this.prepareColumns(columns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }

      columns = columns.filter(column => {
        return !column.hidden
      })

      return [
        ...columns.filter(item => item.first === true),
        ...columns.filter(item => item.first !== true)
      ]
    },
    getTdStyle: function (col, row) {
      if (col.name === 'surplusState' && col.value) {
        return this.getColoredTdStyle(col.value.cssColor, 'white')
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}

